import { Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation, NgZone, Output, EventEmitter, AfterViewInit, HostListener, ChangeDetectorRef } from "@angular/core";
import { RequestBwt } from "../../../models/request/request-bwt";
import { KeyValueObject } from "../../../models/core/KeyValueObject";
import { LookupService } from "../../../services/lookup.service";
import { ActivityStatusEnum, RequestInitTypeEnum, RequestStatus, RequestType, RoleEnum } from "../../../enums";
import { KendoDropdownListComponent } from "../../workflow-transitions/kendo-dropdown-list/kendo-dropdown-list.component";
import { Activity } from "../../../models/activity/activity";
import { RequestsService } from "../../../services/requests.service";
import { AppService } from "../../../../app.service";
import { groupBy, GroupResult, orderBy } from "@progress/kendo-data-query";
import { IntlService } from "@progress/kendo-angular-intl";
import { ActivityType } from "../../../enums/activity-type.enum";
import { toDataSourceRequestString, DataSourceRequestState } from '@progress/kendo-data-query';
import { take } from "rxjs/operators";
import { CellClickEvent, GridComponent, SelectableSettings } from "@progress/kendo-angular-grid";
import { ServiceCentersService } from "../../../services/service-centers.service";
import { ActivitiesService } from "../../../services/activities.service";
import { EngineerLookupModel } from "../../../models/engineers/engineer-lookup-model";
import { ServiceCenterEngineersData } from "../../../models/engineers/service-center-engineers-data";
import { ServiceCenterEngineers } from "../../../models/engineers/service-center-engineers";
import { SecurityService } from "../../../../core/services/security.service";
import { NotificationService } from "../../../../core/services/notification.service";
import { NotificationType } from "../../../../core/services/notification-type";
import { ExceptionCode } from "../../../enums/exception-code.enum";
import { SetCommentModel } from "../../workflow-transitions/set-comment/set-comment.model";
import { DialogRef, DialogService } from "@progress/kendo-angular-dialog";
import { UploadFile } from "../../../models/attachment";
import { CommentKindEnum } from "../../../enums/comment-kind.enum";
import { SetComment } from "../../workflow-transitions/set-comment/set-comment";
import { RequestGroupDto } from "../../../models/request/request-group-dto";
import { MultipleOperationErrorResultComponent } from "../../multiple-operations/multiple-operation-error-result/multiple-operation-error-result.component";
import { MultipleError } from "../../../models/request/multiple-error";
import { ActivityWorkflowTransition } from "../../../models/activity-workflow/activity-workflow-transition";
import { UsersService } from "../../../../admin/users/users.service";
import { UserGroupsService } from "../../../services/user-groups.service";
import { SignalRNotificationsService } from "../../../services/signalr-notifications.service";
import { LaboratoryRequestIndicatorListItem } from "../../../models/laboratory/laboratory-request-indicator-list-item";
import { LaboratoryRequestIndicatorsService } from "../../../services/laboratory-request-indicators.service";
import { UpdateRequestIndicatorValueFromActivity } from "../../../models/laboratory/update-request-indicator-value-from-activity";
import { RequestStatusKindEnum } from "../../../enums/request-status-kind.enum";
import { ActivityPerformerSlotsConfirmationComponent } from "../../workflow-transitions/activity-performer-slots-confirmation/activity-performer-slots-confirmation.component";
import { UserGroupsEnum } from "../../../enums/user-groups-enum";
import { EngineerSettingsDto } from "../../../models/settings/engineer-settings";
import { SettingsService } from "../../../services/settings.service";
import { EngineerVisitPlanningComponent, PlannedDayContext } from "../../engineer-visit-planning/engineer-visit-planning.component";
import { LaboratoriesService } from "../../../services/laboratories.service";
import { LaboratoryIndicatorDto } from "../../../models/laboratory/laboratory-indicator.dto";
import { AlgoritmType } from "../../../../constants/planning.constants";
import { Subject } from "rxjs";
import { PlanningService } from "../../../services/planning.service";

@Component({
	selector: 'request-page-activities',
	templateUrl: './request-page-activities.component.html',
	styleUrls: ['./request-page-activities.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class RequestPageActivitiesComponent implements OnInit, AfterViewInit {

	@ViewChild('requestIndicatorsGrid') requestIndicatorsGrid: GridComponent;

	@Input() request: RequestBwt;
	@Input() isEngineerRole: boolean;

	activities: Activity[] = [];
	requestIndicators: LaboratoryRequestIndicatorListItem[] = [];

	private changeRequestActivitiesStateMessageListener: string = "changeRequestActivitiesState";
	private changeActivityStatusMessageListener: string = "changeActivityStatus";

	private requestStatuses: KeyValueObject[] = [];
	loadingActivities: boolean;
	loadingRequest: boolean;
	loadingRequestIndicators: boolean;

	engineerSettings: EngineerSettingsDto = null;
	editedActivityRowIndex: number;
	isEditing: boolean = false;
	loadingEngineers: boolean = false;
	engineersGrouped: any[] = [];
	engineers: EngineerLookupModel[] = [];
	emptyEngineersMessage: string = "Не найдено инженеров";
	currentUserGroups: KeyValueObject[] = [];
	serviceCenters: KeyValueObject[] = [];
	laboratoryIndicatorsList: LaboratoryIndicatorDto[] = [];

	selectedActivities: number[] = [];
	selectedActivity: Activity = null;
	public activitySelectableSettings: SelectableSettings = { checkboxOnly: false, mode: "single" };
	activityTypes: KeyValueObject[] = [];
	activityTypesForCreatingActivity: KeyValueObject[] = [];
	activityTypeReadOnly: boolean = false;
	nodes: any[] = [];
	showActivitiesGrid: boolean = true;
	showActivityDetails: boolean = true;
	updateFromCurrentClient: boolean = false;
	editedRequestIndicatorGridRowIndex: number;
	editedRequestIndicator: LaboratoryRequestIndicatorListItem = null;

	@Output() refreshRequestEvent: EventEmitter<RequestBwt> = new EventEmitter<RequestBwt>();

	@ViewChild('activitiesGrid') public activitiesGrid: GridComponent;

	get isOnlyStorekeeper() {
		return this.securityService.isOnlyStorekeeper();
	}

	get canEditRequestActivities() {
		return this.securityService.isCanEditRequestActivities()
			&& (this.request == null || this.request.canFullyEditRequest !== false);
	}

	public get isMkInitType(): boolean {
		return this.request.initTypeId === <number>RequestInitTypeEnum.blockChain;
	}

	get groupTreeLogic(): boolean {
		return this.request.isInGroupExt || this.request.isGroup;
	}

	get selectedActivityId(): number {
		if (this.selectedActivities.length === 0) {
			return null;
		}

		return this.selectedActivities[0];
	}

	constructor(
		private lookupService: LookupService,
		private usersService: UsersService,
		protected requestsService: RequestsService,
		protected appService: AppService,
		private intl: IntlService,
		private activitiesService: ActivitiesService,
		private securityService: SecurityService,
		protected notificationService: NotificationService,
		protected dialogService: DialogService,
		private userGroupsService: UserGroupsService,
		private signalR: SignalRNotificationsService,
		private laboratoryRequestIndicatorsService: LaboratoryRequestIndicatorsService,
		private changeDetector: ChangeDetectorRef,
		private settingsService: SettingsService,
		private laboratoriesService: LaboratoriesService,
		private planningService: PlanningService
	) { }

	ngAfterViewInit(): void {
		this.initSignalR(this.request.requestId.toString());
	}

	ngOnInit(): void {
		this.userGroupsService.getUserGroupsByUser().subscribe(resp => {
			this.currentUserGroups = resp;

			if (this.currentUserIsWarehouseEmployee) {
				this.userGroupsService.getUsersByActivityTypeId(this.request.requestId, <number>ActivityType.warehouse).subscribe(resp => {
					this.engineers = resp;
					this.engineersGrouped = orderBy(this.engineers, [{ field: "value", dir: "asc" }]);
					this.loadingEngineers = false;
				});
			}
		});

		this.lookupService.getData("request-statuses", null).subscribe((resp) => {
			this.requestStatuses = resp;
		});

		this.lookupService.getData('activity-types', null).subscribe(resp => {
			this.fillActivityTypes(resp);
		});

		this.loadActivityTypesForCreating();

		this.settingsService.getEngineerSettings().subscribe(resp => {
			this.engineerSettings = resp;
		});

		if (this.isLaboratoryRequestType) {
			this.laboratoriesService.getAllIndicators().subscribe(resp => {
				this.laboratoryIndicatorsList = resp.data;
			});
		}

		this.usersService.getLookupUserServiceCenters().subscribe(resp => {
			this.serviceCenters = resp;
		});

		this.loadActivities(this.request.requestId);
	}

	private initSignalR(entityId: string) {
		this.signalR.startConnection().subscribe(() => {
			this.signalR.addToGroup(entityId);
			this.signalR.getOrCreateMessageListener(this.changeRequestActivitiesStateMessageListener).subscribe(data => {
				this.reloadActivitiesFromSignalR();
			});
			this.signalR.getOrCreateMessageListener(this.changeActivityStatusMessageListener).subscribe(data => {
				this.reloadActivitiesFromSignalR();
			});
		});
	}

	private reloadActivitiesFromSignalR() {
		if (!this.updateFromCurrentClient) {
			this.loadActivities(this.request.requestId);
		}
		else {
			this.updateFromCurrentClient = false;
		}
	}

	editRequest() {
		this.isEditing = !this.isEditing;
	}

	getRequestStatusName(statusId: number): string {
		return this.requestStatuses.some(x => x.id == statusId)
			? this.requestStatuses.find(x => x.id == statusId).name
			: '';
	}

	getRequestStatusDropdownListItemColor(requestStatusId: number): string {
		switch (requestStatusId) {
			case RequestStatus.Registered:
				return "#54dc36";
			case RequestStatus.InProgress:
				return "#dbee22";
			case RequestStatus.Cancelled:
				return "#eb5252";
			case RequestStatus.Stopped:
				return "#b8b8b8";
			default:
				return "#d5d5d5";
		}
	}

	loadRequest(requestId: number) {
		this.loadingRequest = true;
		this.requestsService.getBwtById(requestId).subscribe((resp) => {
			this.request = resp.entity;
			this.refreshRequestEvent.emit(resp.entity);
			this.loadingRequest = false;
		});
	}

	loadActivities(requestId: number, activityId?: number) {
		this.loadingActivities = true;

		this.loadRequestIndicators();

		this.requestsService.getActivities(requestId).subscribe(res => {
			res.forEach(a => {
				a.createdDate = this.appService.parseDateTime(a.createdDate);
				a.planStartDate = this.appService.parseDateTime(a.planStartDate);
				a.planStartDateLocal = this.appService.parseDateTime(a.planStartDateLocal);
				a.dueDate = this.appService.parseDateTime(a.dueDate);
			});

			this.activities = this.isLaboratoryRequestType
				? orderBy(res, [{ field: "planStartDateLocal", dir: "desc" }])
				: orderBy(res, [{ field: "createdDate", dir: "desc" }]);

			if (this.isEngineerRole) {
				let activity = this.activities.find(x => x.statusKindId != <number>RequestStatusKindEnum.final);
				if (activity != null) {
					activityId = activity.activityId;
				}
			}

			if (activityId != null) {
				this.showActivityById(activityId);
			} else if (this.activities.length > 0) {
				this.showActivityById(this.activities[0].activityId);
			}

			this.loadingActivities = false;
			this.changeDetector.detectChanges();
		});
	}

	loadRequestIndicators() {
		if (this.isLaboratoryRequestType) {
			this.loadingRequestIndicators = true;
			this.laboratoryRequestIndicatorsService.getAllByRequestActivities(this.request.requestId).subscribe(resp => {
				this.requestIndicators = resp;
				this.requestIndicators.filter(x => x.shouldBeDoneDateTime != null).forEach(x => {
					x.shouldBeDoneDateTime = this.appService.parseDate(x.shouldBeDoneDateTime);
				});
				this.requestIndicators.filter(x => x.wasDoneDateTime != null).forEach(x => {
					x.wasDoneDateTime = this.appService.parseDate(x.wasDoneDateTime);
				});

				this.loadingRequestIndicators = false;
			});
		}
	}

	public onSelectedActivityChange() {
		if (!this.selectedActivityId)
			return;

		this.activitiesService.getById(this.selectedActivityId).subscribe(x => {
			this.selectedActivity = x.entity;
		});
	}

	parseMultiTimezoneDate(dateTime: any) {
		if (dateTime == null) {
			return '';
		}

		var parsedDate = new Date();

		if (dateTime instanceof Date) {
			parsedDate = dateTime;
		} else if (typeof dateTime === 'string') {
			if (dateTime.startsWith("1753")) {
				return '';
			}

			parsedDate = this.intl.parseDate(dateTime);
		}

		return `${this.intl.formatDate(parsedDate, 'dd.MM.yyyy HH:mm')} ${this.request.utcTimezoneShiftString}`;
	}

	getActivityStatusTagColor(activity: Activity): string {
		return activity.statusColor && activity.statusColor.trim() != ''
			? activity.statusColor
			: '#ffffff';
	}

	getActivityTypeNameById(activityTypeId: number): string {
		const activityType = this.activityTypes.filter(x => x.id === activityTypeId);
		return activityType.length === 1 ? activityType[0].name : '';
	}

	fillActivityTypes(activityTypes: KeyValueObject[]) {
		this.activityTypes = activityTypes;
	}

	private loadActivityTypesForCreating() {
		if (!this.request || !this.request.requestTypeId) {
			this.activityTypesForCreatingActivity = this.activityTypes;
			return;
		}

		const state: DataSourceRequestState = {
			filter: {
				logic: 'and',
				filters: [
					{ field: 'requestTypeId', operator: 'eq', value: this.request.requestTypeId }
				]
			}
		};

		this.lookupService.getData('activity-types', state).subscribe(resp => {
			this.activityTypesForCreatingActivity = resp;
		});
	}

	private ensureCurrentActivityTypeInDropdown(activity: Activity) {
		if (!activity || !activity.activityTypeId) {
			return;
		}

		if (this.activityTypesForCreatingActivity.some(x => x.id === activity.activityTypeId)) {
			return;
		}

		const currentType = this.activityTypes.find(x => x.id === activity.activityTypeId);
		if (currentType) {
			this.activityTypesForCreatingActivity = [...this.activityTypesForCreatingActivity, currentType];
		}
	}

	public rowClass() {
		return {
			'cursor-pointer': true
		};
	}

	public activityEditHandler({ sender, rowIndex, dataItem }) {
		this.closeEditor(sender, this.editedActivityRowIndex);
		this.ensureCurrentActivityTypeInDropdown(dataItem);

		if (this.engineerSettings.activityTypeIds.includes(dataItem.activityTypeId)) {
			this.openEngineerPlanningModal(dataItem, sender, rowIndex);
		}
		else {
			this.editedActivityRowIndex = rowIndex;
			sender.editRow(rowIndex);
			this.refreshEngineers(dataItem);
		}
	}

	private openEngineerPlanningModal(activity: Activity, grid: GridComponent,
		rowIndex: number = this.editedActivityRowIndex, asNewActivity: boolean = false) {

		if (activity.activityTypeId == <number>ActivityType.techSupport) {
			this.requestsService.checkRequestCategoryDevices(this.request.requestId).subscribe(result => {
				if (result.requireCategoryDevice == true && result.hasCategoryDevice == false) {
					this.notificationService.confirmation({
						message: 'Для назначения визита мастера необходимо указать какое оборудование должно быть установлено или обслужено на объекте',
						title: 'Не указано оборудование',
						confirmButtonText: 'Ок',
						showConfirmButton: true,
						showCancelButton: false,
					});
				}
				else {
					this.openEngineerPlanningModalImpl(activity, grid, rowIndex, asNewActivity);
				}
			});
		}
		else {
			this.openEngineerPlanningModalImpl(activity, grid, rowIndex, asNewActivity);
		}
	}

	private openEngineerPlanningModalImpl(activity: Activity, grid: GridComponent,
		rowIndex: number = this.editedActivityRowIndex, asNewActivity: boolean = false) 
	{
		const dialogRef = this.dialogService.open({
			content: EngineerVisitPlanningComponent,
			width: '50%',
		});

		const dialog = <EngineerVisitPlanningComponent>dialogRef.content.instance;

		dialog.requestId = this.request.requestId;
		dialog.requestIntegraCode = this.request.integraCode;
		dialog.performerIntegraCode = activity.performerUserIntegraCode;
		dialog.visitDate = activity.planStartDateLocal;
		dialog.requestServiceCenterId = this.request.serviceCenterId;
		dialog.requestServiceCenterIntegraCode = this.request.serviceCenterIntegraCode;

		dialog.onContinueEvent.subscribe((resp: PlannedDayContext) => {
			dialogRef.close();
			this.closeEditor(grid, rowIndex);

			if (asNewActivity) {
				activity.planStartDate = resp.visitDate;
				activity.planStartDateLocal = resp.visitDate;
				activity.performerUserId = resp.performerId;
				this.createActivityExt(activity, resp);
			}
			else {
				// Откатил NBWT-608
				let oldSelectedPerformerIntegraCode = activity.performerUserIntegraCode;
				if (oldSelectedPerformerIntegraCode) {
					oldSelectedPerformerIntegraCode = oldSelectedPerformerIntegraCode.toLowerCase()
				}

				// activity.performerUserId = resp.performerId; // Откатил NBWT-608
				activity.planStartDate = resp.visitDate;
				activity.planStartDateLocal = resp.visitDate;
				// Откатил NBWT-608
				activity.performerUserIntegraCode = resp.performerIntegraCode;
				activity.performerUserId = null;
				activity.transferInitiatorId = resp.transferInitiatorId;

				// Откатил NBWT-608
				this.updateActivityCoreExt(activity, oldSelectedPerformerIntegraCode, resp, dialogRef);
				// this.updateActivityCore(activity, null);
			}
		});
		dialog.onCancelEvent.subscribe(() => {
			dialogRef.close();
			this.closeEditor(grid, rowIndex);
		});
	}

	private closeEditor(grid, rowIndex) {
		grid.closeRow(rowIndex);
		this.editedActivityRowIndex = undefined;
	}

	updateActivityCoreExt(activity: Activity, oldSelectedPerformerIntegraCode: string,
		plannedDayContext: PlannedDayContext,
		dialogRef: DialogRef
	) {
		this.normalizeActivityPlanDates(activity);
		activity.performerUserOldIntegraCode = oldSelectedPerformerIntegraCode;
		this.activitiesService.updateExt(activity, "Заявка запланирована").subscribe(res => {
			let customerPerformerIntegraCodes = [];

			if (res.data && res.data.oldPerformerHasRoute) {
				customerPerformerIntegraCodes.push(oldSelectedPerformerIntegraCode);
			}

			if (res.data && res.data.newPerformerHasRoute && activity.performerUserIntegraCode != null && oldSelectedPerformerIntegraCode != activity.performerUserIntegraCode) {
				customerPerformerIntegraCodes.push(activity.performerUserIntegraCode);
			}

			if (plannedDayContext.algoritmType === AlgoritmType.yandex && res.data && res.data.needCreateRoute) {
				this.createRoutes(dialogRef, customerPerformerIntegraCodes, plannedDayContext);
			} else {
				dialogRef.close();
				this.loadActivities(this.request.requestId);
			}

			if (res.data.activityTrackingWasRemoved) {
				this.notificationService.info({
					title: 'Маршруты',
					message: 'По заявке были построенные маршруты. Рекомендуется перераспределить маршруты в планировании.',
					notificationType: NotificationType.SweetAlert
				});
			}
		});
	}

	createRoutes(dialogRef: DialogRef, customerPerformerIntegraCodes: string[], plannedDayContext: PlannedDayContext) {
		let cancelStartPlanning$ = new Subject<void>();
		this.planningService.startPlanning(plannedDayContext.visitDate, customerPerformerIntegraCodes, null, null, false, cancelStartPlanning$).subscribe(planningResp => {
			if (planningResp.isSuccessful) {
				this.planningService.confirmPlanning(planningResp.data, false).subscribe(() => {
					if (dialogRef) {
						dialogRef.close();
					}
					this.loadActivities(this.request.requestId);
				});
			} else {
				this.notificationService.error({
					title: 'Ошибка',
					message: 'Произошел сбой в сервисе маршрутизации. Построение маршрута не может быть выполнено в данный момент.',
					notificationType: NotificationType.SweetAlert
				});
			}
		}, () => {
			this.notificationService.error({
				title: 'Ошибка',
				message: 'Произошел сбой в сервисе маршрутизации. Построение маршрута не может быть выполнено в данный момент.',
				notificationType: NotificationType.SweetAlert
			});

			cancelStartPlanning$.next();
		});
	}

	addNewActivity() {
		this.activitiesGrid.addRow(this.createNewActivity());
	}

	createNewActivity(): Activity {
		let now = new Date();
		let utc = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
		let local = new Date(utc.getTime() + (this.request.utcTimezoneShift * 60 * 60 * 1000));
		let createdDate = new Date(local.getTime());
		let planStartDateLocal = new Date(local.getTime());
		planStartDateLocal.setSeconds(0, 0);
		let planStartDate = new Date(planStartDateLocal.getTime());

		var activityTypeId = this.activityTypesForCreatingActivity.length > 0
			? this.activityTypesForCreatingActivity[0].id
			: <number>ActivityType.inspection;
		var performerUserId = null;

		if (this.currentUserIsWarehouseEmployee
			&& this.activityTypesForCreatingActivity.some(x => x.id === <number>ActivityType.warehouse)) {
			activityTypeId = <number>ActivityType.warehouse;
			performerUserId = this.securityService._currentUser.userId;
		}

		let activity = {
			requestId: this.request.requestId,
			createdDate: createdDate,
			planStartDate: planStartDate,
			planStartDateLocal: planStartDateLocal,
			activityTypeId: activityTypeId,
			performerUserId: performerUserId
		} as Activity;

		return activity;
	}

	onPlanStartDateLocalChange(activity: Activity, value: Date): void {
		if (!activity || !value) {
			return;
		}

		const source = value instanceof Date ? value : new Date(value);
		const date = activity.createdDate && source === activity.createdDate
			? new Date(source.getTime())
			: source;
		date.setSeconds(0, 0);
		activity.planStartDateLocal = date;
	}

	private normalizeActivityPlanDates(activity: Activity): void {
		if (!activity) {
			return;
		}

		if (activity.planStartDateLocal) {
			activity.planStartDateLocal = this.cloneDateWithoutSeconds(activity.planStartDateLocal);
		}

		if (activity.planStartDate) {
			activity.planStartDate = this.cloneDateWithoutSeconds(activity.planStartDate);
		}
	}

	private cloneDateWithoutSeconds(value: Date): Date {
		const date = new Date(value instanceof Date ? value.getTime() : value);
		date.setSeconds(0, 0);
		return date;
	}

	public activityTypeChange(activity: Activity) {
		if (this.engineerSettings.activityTypeIds.some(x => x == activity.activityTypeId)) {
			if (activity.activityId == null) {
				activity.planStartDate = null;
				activity.planStartDateLocal = null;
			}

			this.openEngineerPlanningModal(activity, this.activitiesGrid, this.editedActivityRowIndex, true);
		}
		else {
			this.refreshEngineers(activity);
		}
	}

	public refreshEngineers(activity: Activity): void {
		if (!activity.activityTypeId) {
			return;
		}

		this.loadingEngineers = true;

		this.userGroupsService.getUsersByActivityTypeId(activity.requestId, activity.activityTypeId, activity.serviceCenterId).subscribe(resp => {
			this.engineers = resp;

			this.engineersGrouped = orderBy(this.engineers, [{ field: "value", dir: "asc" }]);
			this.loadingEngineers = false;

			if (!this.engineersGrouped.some(x => x.engineerUserId == activity.performerUserId)) {
				activity.performerUserId = null;
			}

			let contragentPerformer = this.engineersGrouped.find(x => x.contragentId == this.request.customerContragentId);
			if (contragentPerformer != null) {
				activity.performerUserId = contragentPerformer.engineerUserId;
			}
		});

		return;
	}

	activityPerformerUserDisabled(activity: Activity): boolean {
		return !!activity
			&& !!activity.performerUserId
			&& this.engineers.map(m => m.engineerUserId).includes(activity.performerUserId)
			&& this.isOnlyStorekeeper;
	}

	performerChangeUser(dataItem: Activity) {
		if (dataItem.statusId === 13 || (dataItem.statusId == 24 && this.request.customerContragentId == 1055))
			return dataItem.changePerformerUserId;
		else {

			return dataItem.performerUserId;
		}
	}

	changePerformerUser(dataItem: Activity, value) {
		if (dataItem.statusId === 13 || (dataItem.statusId == 24 && this.request.customerContragentId == 1055))
			dataItem.changePerformerUserId = value;
		else
			dataItem.performerUserId = value;
	}

	public activitySaveHandler(eventArgs: any) {
		const isUpdating = !!eventArgs.dataItem.activityId;
		let activityData = <Activity>eventArgs.dataItem;

		if (activityData.performerUserId == null) {
			if (isUpdating) {
				this.activitySaveAsUpdate(activityData);
			}
			else {
				this.AddNewActivity(activityData);
			}
		}
		else {
			this.activitiesService.checkActivityPerformerSlots(activityData.performerUserId, activityData.planStartDateLocal).subscribe(resp => {
				let activitySlots = isUpdating
					? resp.data.filter(x => x.activityId != eventArgs.dataItem.activityId)
					: resp.data;

				if (activitySlots.length > 0) {
					let performerUserName = this.engineersGrouped.find(x => x.engineerUserId == activityData.performerUserId).name;
					const dialogRef = this.dialogService.open({
						title: `На это время у ${performerUserName} уже есть назначенные заявки`,
						content: ActivityPerformerSlotsConfirmationComponent
					});

					const dialog = <ActivityPerformerSlotsConfirmationComponent>dialogRef.content.instance;
					dialog.activityPerformerSlots = activitySlots;

					dialog.onCancelEvent.subscribe(() => {
						eventArgs.sender.editRow(eventArgs.rowIndex);
						dialogRef.close();
					});
					dialog.onContinueEvent.subscribe(() => {
						if (isUpdating) {
							this.activitySaveAsUpdate(activityData);
						}
						else {
							this.AddNewActivity(activityData);
						}
						eventArgs.dataItem = null;
						dialogRef.close();
					});
				}
				else {
					if (isUpdating) {
						this.activitySaveAsUpdate(activityData);
					}
					else {
						this.AddNewActivity(activityData);
					}

					eventArgs.dataItem = null;
				}
			});
		}
	}

	private activitySaveAsUpdate(activity: Activity) {
		this.activitiesService.getById(activity.activityId).subscribe(async activityOld => {
			let engineerIdNew = activity.performerUserId;
			let engineerIdOld = activityOld.entity.performerUserId;

			this.updateActivityIfEngineerChanged(activity, engineerIdNew, engineerIdOld);
		});
	}

	private updateActivityIfEngineerChanged(dataItem: any, engineerIdNew: number, engineerIdOld: number): void {
		let commentModel: SetCommentModel = null;

		if (engineerIdOld !== engineerIdNew && !this.request.isInGroupExt && engineerIdOld != null && engineerIdNew != null) {
			const dialogRef = this.dialogService.open({
				content: SetComment,
				width: this.appService.isMobileDevice ? '90%' : '500px',
				title: "Укажите причину смены инженера"
			});

			const customerObjectForm = <SetComment>dialogRef.content.instance;

			if (customerObjectForm.setCommentModel == null) {
				customerObjectForm.setCommentModel = new SetCommentModel('');
			}

			customerObjectForm.setCommentModel.commentKind = CommentKindEnum.internal;

			customerObjectForm.onContinueEvent.subscribe((setCommentModel: SetCommentModel) => {
				commentModel = setCommentModel;

				this.updateActivityIfCapacityExceeded(dataItem, () => {

					let uploadAttachments: UploadFile[] = [];
					this.requestsService.addComment(
						{
							text: `Причина смены инженера: ${commentModel.commentText}`,
							requestId: this.request.requestId,
							activityId: dataItem.activityId,
							uploadAttachments: uploadAttachments,
							notifyCustomer: false,
							notifyEngineer: false,
							engineerNotifyWays: [],
							commentKind: CommentKindEnum.system
						}).subscribe(x => { });

					this.requestsService.addComment(
						{
							text: `Причина смены инженера по активности [${dataItem.activityId}]: ${commentModel.commentText}`,
							requestId: this.request.requestId,
							activityId: null,
							uploadAttachments: uploadAttachments,
							notifyCustomer: false,
							notifyEngineer: false,
							engineerNotifyWays: [],
							commentKind: CommentKindEnum.system
						}).subscribe(x => { });

					this.loadActivities(this.request.requestId);

				});

			});
		} else {
			this.updateActivityIfCapacityExceeded(dataItem, () => {
				this.loadActivities(this.request.requestId);
			});
		}
	}

	private AddNewActivity(activity: Activity): void {
		this.loadingActivities = true;

		if (activity.performerUserId == null) {
			this.createActivity(activity);
		}
		else {
			this.requestsService.getRequestsTotalTime({
				activityInfo: { requestId: this.request.requestId, activityTypeId: activity.activityTypeId },
				userIds: [activity.performerUserId],
				date: activity.planStartDateLocal
			}).subscribe(x => {
				if (!x.isSuccessful) {
					this.notificationService.error({
						title: 'Ошибка',
						message: x.errorDescription,
						notificationType: NotificationType.SweetAlert
					});
				} else {
					if (x.data[0].isCapacityExceeded) {
						this.notificationService.confirmation({
							title: 'Предупреждение',
							enableHtml: true,
							message: `Обнаружена попытка назначить активность на сотрудника с превышением запаса рабочего времени. Продолжить?`,
							type: 'question',
							confirmButtonText: 'Продолжить',
							cancelButtonText: 'Отмена',
							showCloseButton: false
						},
							() => {
								this.createActivity(activity);
							},
							() => {
								this.loadingActivities = false;
							});
					} else {
						this.createActivity(activity);
					}
				}
			});
		}
	}

	private AddNewActivityExt(activity: Activity, plannedDayContext: PlannedDayContext): void {
		this.loadingActivities = true;

		if (activity.performerUserId == null) {
			this.createActivityExt(activity, plannedDayContext);
		}
		else {
			this.requestsService.getRequestsTotalTime({
				activityInfo: { requestId: this.request.requestId, activityTypeId: activity.activityTypeId },
				userIds: [activity.performerUserId],
				date: activity.planStartDateLocal
			}).subscribe(x => {
				if (!x.isSuccessful) {
					this.notificationService.error({
						title: 'Ошибка',
						message: x.errorDescription,
						notificationType: NotificationType.SweetAlert
					});
				} else {
					if (x.data[0].isCapacityExceeded) {
						this.notificationService.confirmation({
							title: 'Предупреждение',
							enableHtml: true,
							message: `Обнаружена попытка назначить активность на сотрудника с превышением запаса рабочего времени. Продолжить?`,
							type: 'question',
							confirmButtonText: 'Продолжить',
							cancelButtonText: 'Отмена',
							showCloseButton: false
						},
							() => {
								this.createActivityExt(activity, plannedDayContext);
							},
							() => {
								this.loadingActivities = false;
							});
					} else {
						this.createActivityExt(activity, plannedDayContext);
					}
				}
			});
		}
	}

	private createActivity(activity: Activity): void {
		this.normalizeActivityPlanDates(activity);
		this.activitiesService.create(activity, NotificationType.SweetAlert, true).subscribe(x => {
			var needReloadActivities = true;

			if (!x.isSuccessful) {

				if (x.code === 948) {
					this.showGroupError(x.errorDescription);

				} else if (x.code === <number>ExceptionCode.engineerHasDifferentThanRequestServiceCenterException) {

					this.notificationService
						.confirmation({
							message: x.errorDescription,
							type: 'question',
							confirmButtonText: 'Изменить Исполнителя (СЦ)',
							cancelButtonText: 'Отмена',
							showCloseButton: false
						},
							() => {
								activity.skipExceptions.push(<number>ExceptionCode.engineerHasDifferentThanRequestServiceCenterException);
								this.AddNewActivity(activity);
								return;
							},
							() => {
								needReloadActivities = false;
								this.loadingActivities = false;
								return;
							}
						);


				} else {
					this.notificationService.error({
						title: 'Ошибка',
						message: x.errorDescription,
						notificationType: NotificationType.SweetAlert
					});
				}

				this.loadingActivities = false;

			} else {
				if (needReloadActivities)
					this.loadActivities(this.request.requestId);

				// if (needReloadRequest)
				// 	this.loadRequest(this.request.requestId);
			}
		});
	}

	private createActivityExt(activity: Activity, plannedDayContext: PlannedDayContext): void {
		this.normalizeActivityPlanDates(activity);
		this.activitiesService.createExt(activity, null, false, true).subscribe(x => {
			var needReloadActivities = true;

			if (!x.isSuccessful) {

				if (x.code === 948) {
					this.showGroupError(x.errorDescription);

				} else if (x.code === <number>ExceptionCode.engineerHasDifferentThanRequestServiceCenterException) {

					this.notificationService
						.confirmation({
							message: x.errorDescription,
							type: 'question',
							confirmButtonText: 'Изменить Исполнителя (СЦ)',
							cancelButtonText: 'Отмена',
							showCloseButton: false
						},
							() => {
								activity.skipExceptions.push(<number>ExceptionCode.engineerHasDifferentThanRequestServiceCenterException);
								this.AddNewActivityExt(activity, plannedDayContext);
								return;
							},
							() => {
								needReloadActivities = false;
								this.loadingActivities = false;
								return;
							}
						);


				} else {
					this.notificationService.error({
						title: 'Ошибка',
						message: x.errorDescription,
						notificationType: NotificationType.SweetAlert
					});
				}

				this.loadingActivities = false;

			} else {
				if (x.data && x.data.needCreateRoute) {
					this.createRoutes(null, [plannedDayContext.performerIntegraCode], plannedDayContext);
				}

				if (needReloadActivities)
					this.loadActivities(this.request.requestId);

				// if (needReloadRequest)
				// 	this.loadRequest(this.request.requestId);
			}
		});
	}

	updateActivityIfCapacityExceeded(activity: Activity, onSuccess: Function) {
		this.requestsService.getRequestsTotalTime({
			activityInfo: { activityId: activity.activityId, requestId: this.request.requestId, activityTypeId: activity.activityTypeId },
			userIds: [activity.performerUserId],
			date: activity.planStartDateLocal
		}).subscribe(x => {
			if (!x.isSuccessful) {
				this.notificationService.error({
					title: 'Ошибка',
					message: x.errorDescription,
					notificationType: NotificationType.SweetAlert
				});
			} else {
				if (x.data[0].isCapacityExceeded) {
					this.notificationService.confirmation({
						title: 'Предупреждение',
						enableHtml: true,
						message: `Обнаружена попытка назначить активность на сотрудника с превышением запаса рабочего времени. Продолжить?`,
						type: 'question',
						confirmButtonText: 'Продолжить',
						cancelButtonText: 'Отмена',
						showCloseButton: false
					},
						() => {
							this.updateActivityCore(activity, onSuccess);
						},
						() => {
						});
				} else {
					this.updateActivityCore(activity, onSuccess);
				}
			}
		});
	}

	updateActivityCore(activity: Activity, onSuccess: Function) {
		this.normalizeActivityPlanDates(activity);
		activity.performerUserIntegraCode = null;
		this.activitiesService.update(activity, 'Наряд обновлен', true).subscribe(x => {
			if (x.isSuccessful) {
				this.loadActivities(this.request.requestId);
				if (!!onSuccess)
					onSuccess();

			} else {
				if (x.code === 948) {
					this.showGroupError(x.errorDescription);
				} else if (x.code === <number>ExceptionCode.engineerHasDifferentThanRequestServiceCenterException) {

					this.notificationService
						.confirmation({
							message: x.errorDescription,
							type: 'question',
							confirmButtonText: 'Изменить Исполнителя (СЦ)',
							cancelButtonText: 'Отмена',
							showCloseButton: false
						},
							() => {

								if (activity.skipExceptions == null)
									activity.skipExceptions = [];

								activity.skipExceptions.push(<number>ExceptionCode.engineerHasDifferentThanRequestServiceCenterException);
								this.updateActivityCore(activity, onSuccess);
								return;
							},
							() => {
								this.loadingActivities = false;
								return;
							}
						);


				} else {
					this.notificationService.error({
						title: 'Ошибка',
						message: x.errorDescription,
						notificationType: NotificationType.SweetAlert
					});
				}
			}
		});

	}

	canSaveActivity(activity: Activity) {
		let performerUserValid = this.isEngineerActivity(activity) || activity.performerUserId;
		return activity.planStartDateLocal && activity.activityTypeId && performerUserValid;
	}

	private showGroupError(msg: string): void {
		let errors = (<RequestGroupDto[]>this.nodes).map(m => new MultipleError(m.requestId, ""));

		const dialogRef = this.dialogService.open({ content: MultipleOperationErrorResultComponent, width: '50%', height: '50%' });

		const multipleOperationErrorResultComponent = <MultipleOperationErrorResultComponent>dialogRef.content.instance;
		multipleOperationErrorResultComponent.errors = errors;
		multipleOperationErrorResultComponent.heightPercent = 53;
		multipleOperationErrorResultComponent.headerText = msg;
	}

	public activityRemoveHandler({ dataItem }: any) {
		this.activitiesService.remove(`${(<Activity>dataItem).activityId}`, 'Наряд удален', '').subscribe(x => {

			if (x.isSuccessful) {
				this.loadActivities(this.request.requestId);
				this.selectedActivities = [];
				this.selectedActivity = null;
			}
		});
	}

	canDeleteActivity(activity: Activity): boolean {
		return this.canEditRequestActivities &&
			this.securityService.isAdmin() &&
			activity &&
			activity.statusKindId != <number>RequestStatusKindEnum.final;
	}

	onActivityChangeStatus(transition: ActivityWorkflowTransition) {
		this.loadActivities(this.request.requestId);
		this.loadRequest(this.request.requestId);
		this.onSelectedActivityChange();
		//this.loadRequest(this.request.requestId);
		// if (this.activityDevices) {
		// 	this.activityDevices.refreshDevicesList();
		// }
	}

	isEngineerActivity(activity: Activity) {
		const engineerActivityTypes = [ActivityType.inspection, ActivityType.techSupport, ActivityType.waterSampling];
		return engineerActivityTypes.some(x => activity.activityTypeId == <number>x);
	}

	showActivityById(activityId: number) {

		if (this.appService.isMobileDevice) {
			this.showActivitiesGrid = false;
			this.showActivityDetails = true;
		}

		this.selectedActivities = [];
		let activity = this.activities.find(x => x.activityId == activityId);
		if (!this.statusIsCanceled(activity)) {
			this.selectedActivities.push(activityId);
		}
		this.onSelectedActivityChange();
	}

	public statusIsCanceled(item: any): boolean {
		return item && item.statusId == <number>ActivityStatusEnum.cancelled;
	}

	createNewRequestIndicator(): LaboratoryRequestIndicatorListItem {
		var indicator = new LaboratoryRequestIndicatorListItem();
		return indicator;
	}

	saveRequestIndicator({ dataItem, rowIndex }: any) {
		if (!this.hasInaccurary(dataItem)) {
			dataItem.inaccuracyText = null;
		}

		dataItem.valueText = this.formatStringNumber(dataItem.valueText);
		dataItem.inaccuracyText = this.formatStringNumber(dataItem.inaccuracyText);


		let valueText: string = dataItem.valueText;
		let inaccuracyText: string = dataItem.inaccuracyText;

		if (this.isEmpty(valueText) && this.isEmpty(inaccuracyText)) {
			this.saveRequestIndicatorImpl(dataItem);
		}
		else if (!valueText.includes('<') && !valueText.includes('>')) {
			if (this.isNotNumber(valueText) && this.isNotNumber(valueText.slice(1, valueText.length))) {
				this.showIndicatorsError("Введите корректное значение показателя", rowIndex);
			}
			else if (this.hasInaccurary(dataItem) && this.isEmpty(inaccuracyText)) {
				this.showIndicatorsError("Не указана погрешность", rowIndex);
			}
			else if (this.hasInaccurary(dataItem) && this.isNotNumber(inaccuracyText)) {
				this.showIndicatorsError("Введите корректное значение погрешности", rowIndex);
			}
			else {
				dataItem.value = this.buildNumber(valueText);
				dataItem.inaccuracy = this.buildNumber(inaccuracyText);
				dataItem.exceeding = 0;

				this.saveRequestIndicatorImpl(dataItem);
			}
		}
		else if (this.isNotNumber(valueText) && this.isNotNumber(valueText.slice(1, valueText.length))) {
			this.showIndicatorsError("Введите корректное значение показателя", rowIndex);
		}
		else {
			dataItem.value = this.buildNumber(valueText.slice(1, valueText.length));
			dataItem.inaccuracy = null;
			dataItem.exceeding = valueText.includes('>') ? 1 : -1;

			this.saveRequestIndicatorImpl(dataItem);
		}
	}

	showIndicatorsError(text: string, rowIndex: number) {
		this.notificationService.error({
			title: text,
			message: "",
			notificationType: NotificationType.Toast,
		});
		setTimeout(() => this.requestIndicatorsGrid.editRow(rowIndex), 10);
	}

	saveRequestIndicatorImpl(dataItem) {
		let model = {
			laboratoryRequestIndicatorId: dataItem.laboratoryRequestIndicatorId,
			activityId: dataItem.activityId,
			value: dataItem.value,
			valueText: dataItem.valueText,
			inaccuracy: dataItem.inaccuracy,
			exceeding: dataItem.exceeding,
			inaccuracyText: dataItem.inaccuracyText
		} as UpdateRequestIndicatorValueFromActivity;

		this.laboratoryRequestIndicatorsService.changeValueFromActivity(model).subscribe(() => {
			this.editedActivityRowIndex = 0;
			this.editedRequestIndicator = null;
			this.loadRequestIndicators();
		});
	}

	removeRequestIndicator({ dataItem, rowIndex }: any) {
		this.loadingRequestIndicators = true;
		dataItem.stringValue = null;
		this.saveRequestIndicator({ dataItem, rowIndex });
	}

	requestIndicatorsGridCellClick(event: CellClickEvent): void {
		if (!this.canEditRequestWaterSampling) {
			return;
		}

		this.closeCurrentRequestIndicatorGridRow(event.sender);
		this.editedRequestIndicatorGridRowIndex = event.rowIndex;
		this.editedRequestIndicator = { ...event.dataItem };
		event.sender.editRow(event.rowIndex);
	}

	requestIndicatorsGridEdit({ sender, rowIndex, dataItem }) {
		this.closeCurrentRequestIndicatorGridRow(sender);
		this.editedRequestIndicatorGridRowIndex = rowIndex;
		this.editedRequestIndicator = { ...dataItem };
		sender.editRow(rowIndex);
	}

	cancelRequestIndicator({ dataItem, sender }) {
		this.closeCurrentRequestIndicatorGridRow(sender);
		this.editedRequestIndicatorGridRowIndex = null;
		this.editedRequestIndicator = null;
	}

	isValidIndicatorValue(item: LaboratoryRequestIndicatorListItem): boolean {
		return item.value == null ||
			((item.normalValueMin == null || item.value >= item.normalValueMin) &&
				(item.normalValueMax == null || item.value <= item.normalValueMax));
	}

	hasInaccurary(item: LaboratoryRequestIndicatorListItem): boolean {
		if (item.laboratoryIndicatorId) {
			let indicatorItem = this.laboratoryIndicatorsList.find(x => x.laboratoryIndicatorId == item.laboratoryIndicatorId);
			return indicatorItem.code != 'smell';
		}

		return true;
	}

	private closeCurrentRequestIndicatorGridRow(grid: GridComponent): void {
		if (this.editedRequestIndicatorGridRowIndex != null && this.editedRequestIndicatorGridRowIndex + 1) {
			grid.closeRow(this.editedRequestIndicatorGridRowIndex);

			if (this.editedRequestIndicator != null) {
				let currentIndicator = this.activityIndicators.find(x =>
					x.laboratoryRequestIndicatorId == this.editedRequestIndicator.laboratoryRequestIndicatorId);
				currentIndicator.stringValue = this.editedRequestIndicator.stringValue;
				currentIndicator.valueText = this.editedRequestIndicator.valueText;
				currentIndicator.inaccuracyText = this.editedRequestIndicator.inaccuracyText;
				this.editedRequestIndicator = null;
			}
		}
	}

	formatStringNumber(value: string): string {
		if (value != null && value.includes('.')) {
			value = value.replace('.', ',');
		}
		return value;
	}

	onKeyPress(event: KeyboardEvent, allowSpecChars: boolean = true) {
		const input = event.target as HTMLInputElement;
		const value = input.value;
		const key = event.key;
		const cursorPosition = input.selectionStart || 0;
		const dotChars = ['.', ','];

		// Разрешаем: цифры, Backspace, Delete, стрелки и т.д.
		if (['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(key)) {
			return true;
		}

		if (!allowSpecChars && ['<', '>', '-'].includes(key)) {
			event.preventDefault();
			return false;
		}

		// Разрешаем в начале символы '<>,'
		if ((['<', '>', '-'].includes(key) && cursorPosition === 0) ||
			(cursorPosition == 1 && ['<', '>'].includes(value[0]) && key === '-')) {
			return true;
		}

		// Запрещаем запятную после символов '<>,'
		if (cursorPosition !== 0 && dotChars.includes(key) && !/[0-9]/.test(value[cursorPosition - 1])) {
			event.preventDefault();
			return false;
		}

		// Разрешаем точку, только если её ещё нет и она не в начале/конце
		if (dotChars.includes(key)) {
			const dotIndex = value.indexOf(',');
			const isAtStart = cursorPosition === 0;

			if (dotIndex === -1 && !isAtStart) {
				// заменяем точку на запятую
				if (key === '.') {
					input.value = value.slice(0, cursorPosition) + ',' + value.slice(cursorPosition);
					event.preventDefault();
					return false;
				}

				return true;
			} else {
				event.preventDefault();
				return false;
			}
		}

		// Разрешаем только цифры
		if (!/[0-9]/.test(key)) {
			event.preventDefault();
			return false;
		}

		return true;
	}

	isNotNumber(value: string): boolean {
		return isNaN(this.buildNumber(value));
	}

	buildNumber(value: string): number {
		if (!this.isEmpty(value)) {
			value = value.replace(',', '.');
			return Number(value);
		}

		return NaN;
	}

	isEmpty(value: string) {
		return value == null || value.trim() == '';
	}

	@HostListener('window:keydown.enter')
	onEnterKeyDown(): void {
		if (this.isLaboratoryRequestType && this.editedRequestIndicatorGridRowIndex + 1) {
			let dataItem = this.activityIndicators.find(x => x.laboratoryRequestIndicatorId == this.editedRequestIndicator.laboratoryRequestIndicatorId);
			let rowIndex = this.editedRequestIndicatorGridRowIndex;
			this.requestIndicatorsGrid.closeRow(rowIndex);
			setTimeout(() => this.saveRequestIndicator({ dataItem, rowIndex }), 10);
		}
	}

	validAccuracy(item: LaboratoryRequestIndicatorListItem): boolean {
		let validAccuracy = false;

		if (item.accuracy == null || item.accuracy == 0) {
			validAccuracy = true;
		}
		else if (item.valueText != null && item.valueText.trim() != '') {
			var itemParts = item.valueText.split(',');
			if (itemParts.length == 2) {
				validAccuracy = itemParts[1].trim().length >= item.accuracy;
			}
		}

		return validAccuracy;
	}

	getDoubleAccuracy(item: LaboratoryRequestIndicatorListItem) {
		return item.accuracy != null
			? '0.' + '0'.repeat(item.accuracy - 1) + '1'
			: '0';
	}

	get activityIndicators(): LaboratoryRequestIndicatorListItem[] {
		return this.requestIndicators.filter(x => x.activityId == this.selectedActivityId);
	}

	get isLaboratoryRequestType(): boolean {
		return this.request.requestTypeId == <number>RequestType.laboratory;
	}

	get contentHeight(): number {
		return window.innerHeight / 2;
	}

	get currentUserIsWarehouseEmployee(): boolean {
		return this.currentUserGroups.some(x => x.id == <number>UserGroupsEnum.warehouse);
	}

	getNameById(data: KeyValueObject[], id: number) {
		this.appService.getNameById(data, id);
	}

	get canEditRequestWaterSampling(): boolean {
        return this.request.requestStatusId == <number>RequestStatus.TrialExecution ||
            this.request.requestStatusId == <number>RequestStatus.TrialTaskPreparation ||
            this.request.requestStatusId == <number>RequestStatus.TrialsCompleted ||
            this.request.requestStatusId == <number>RequestStatus.TrialProtocolAdjustment
    }

	get userIsEngineerRight(): boolean {
        return this.securityService.hasClaim('role-Engineer-right');
    }
}